<template>
  <v-row no-gutters justify="space-between" class="rowContent">
    <div>
      <ButtonLike
        size="large"
        :count="sumLike"
        :isLiked="isLiked"
        :entityId="entityId"
        :type="entityName"
        oneway
        @onLike="$emit('onLikePost', arguments[0])"
      />
    </div>
    <div><ButtonComment size="large" :count="sumComment" /></div>
    <!-- <div><ButtonShare size="large" /></div> -->
  </v-row>
</template>
<script>
import ButtonLike from "@/components/Buttons/ButtonLike";
import ButtonComment from "@/components/Buttons/ButtonComment";
import ButtonShare from "@/components/Buttons/ButtonShare";
export default {
  props: {
    entityId: {},
    entityName: {},
    isLiked: { type: Boolean, default: false },
    totalComment: { type: Number, default: null },
    totalLike: { type: Number, default: null },
  },
  components: { ButtonLike, ButtonComment, ButtonShare },
  data() {
    return {
      sumComment: 0,
      sumLike: 0,
    };
  },
  watch: {
    totalComment: {
      immediate: true,
      handler(val) {
        this.sumComment = val;
      },
    },
    totalLike: {
      immediate: true,
      handler(val) {
        this.sumLike = val;
      },
    },
  },
};
</script>
